import { useEffect, useState } from 'react';
import styles from './Feed.module.scss';
import { Messages } from './components/Messages/Messages';
import { Tabs } from './components/Tabs/Tabs';
import cx from 'classnames';
import { BlockWrapperWithSpinner, Icon, Spinner, Text } from 'components';
import { useDevice } from 'hooks';
import { FeedMessagesAmount } from 'services/patientService';
import {
  selectActiveFeedTab,
  selectFeedMessagesAmount,
  selectFeedMessagesAmountIsLoading,
  selectFeedMessagesFilter,
  selectFeedMessagesIsLoading,
} from 'store/dashboard/selectors';
import { dashboardActions } from 'store/dashboard/slice';
import { useDispatch, useSelector } from 'store/utils';

export const Feed = () => {
  const dispatch = useDispatch();

  const { isTablet, isPhone } = useDevice();

  const [isCollapsed, setIsCollapsed] = useState(true);

  const feedAmount = useSelector(selectFeedMessagesAmount);
  const feedMessagesFilter = useSelector(selectFeedMessagesFilter);

  const feedAmountIsLoading = useSelector(selectFeedMessagesAmountIsLoading);
  const feedIsLoading = useSelector(selectFeedMessagesIsLoading);
  const activeFeedTab = useSelector(selectActiveFeedTab);

  useEffect(() => {
    if (!isTablet && !isPhone) setIsCollapsed(false);
  }, [isTablet, isPhone]);

  useEffect(() => {
    dispatch(dashboardActions.getFeedMessagesAmount());
  }, [dispatch]);

  useEffect(() => {
    dispatch(dashboardActions.getFeed(activeFeedTab));
  }, [dispatch, feedMessagesFilter, activeFeedTab]);

  const messagesTotal = Object.values(feedAmount).reduce((acc, amount) => acc + amount, 0);

  const onDropdownArrorClickHandler = () => setIsCollapsed((prev) => !prev);

  const setActiveTab = (tab: keyof FeedMessagesAmount) => {
    dispatch(dashboardActions.setActiveFeedTab(tab));
  };

  const listSpinner =
    isTablet || isPhone ? (
      <div className={styles.messagesLoader}>
        <Spinner isLoading />
      </div>
    ) : (
      <BlockWrapperWithSpinner isLoading transparent />
    );

  const content = !isCollapsed && (
    <div className={styles.content}>
      {feedAmountIsLoading ? (
        <BlockWrapperWithSpinner isLoading transparent />
      ) : (
        <>
          <div className={styles.controls}>
            <Tabs activeTab={activeFeedTab} setActiveTab={setActiveTab} />
          </div>
          <div className={styles.feedMessagesContainer}>{feedIsLoading ? listSpinner : <Messages />}</div>
        </>
      )}
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Text type="h4" className={styles.title}>
          Messages feed
        </Text>
        <div className={styles.headerControls}>
          <div className={styles.counter}>
            <Text type="h5" className={cx({ [styles.counterTextPadding]: messagesTotal > 99 })}>
              {messagesTotal}
            </Text>
          </div>
          {isTablet && (
            <button
              className={cx(styles.collapseButton, { [styles.isCollapsed]: isCollapsed })}
              onClick={onDropdownArrorClickHandler}>
              <Icon name="ArrowDown" />
            </button>
          )}
        </div>
      </div>
      {content}
    </div>
  );
};
